// extracted by mini-css-extract-plugin
export var actionText = "_n9-4";
export var container = "_n9-0";
export var leftSection = "_n9-1";
export var rightSection = "_n9-2";
export var settingsButton = "_n9-6";
export var settingsIcon = "_n9-7";
export var shortcut = "_n9-5";
export var shortcutGroup = "_n9-3";